module.exports = __webpack_public_path__ + "images/3442b9ef8e824e76a2d414cff797d622.png";